import Cookies from 'js-cookie';
/**
 * TODO: Replace other implementations of cookie handling with the one from this shared package.
 */
export function deleteCookie(name, options) {
    Cookies.remove(name, options);
}
export var getCookie = function (name) {
    return Cookies.get(name);
};
export var setCookie = function (name, value, options) {
    Cookies.set(name, "".concat(value), options);
};
